import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-toggle-group',
  templateUrl: './button-toggle-group.component.html',
  styleUrl: './button-toggle-group.component.scss',
})
export class ButtonToggleGroupComponent {
  @Input() variant: (typeof variantsButtonToggleGroup)[number] = 'primary';
  @Input() size: (typeof sizesButtonToggleGroup)[number] = 'small';

  @Output() handleChange: EventEmitter<Value> = new EventEmitter();

  selected: Value | null = null;
  _options: OptionButtonToggleGroup[] = [];

  constructor() {}

  get options() {
    return this._options;
  }
  @Input({ required: true }) set options(options: OptionButtonToggleGroup[]) {
    this._options = options;
  }

  @Input() set initialValue(val: Value | null) {
    this.selected = val;
  }

  getNgClass(option: OptionButtonToggleGroup) {
    return {
      [`variant-${this.variant}`]: true,
      [`size-${this.size}`]: true,
      selected: option.value === this.selected,
      'is-disabled': !!option?.disabled,
    };
  }

  handleClick(option: OptionButtonToggleGroup) {
    if (option.disabled) return;

    this.selected = option.value;
    this.handleChange.emit(option.value);
  }
}

export interface OptionButtonToggleGroup {
  name: string;
  value: boolean | string;
  disabled?: boolean;
}

export const sizesButtonToggleGroup = ['small', 'large'];

export const variantsButtonToggleGroup = ['primary'];

type Value = OptionButtonToggleGroup['value'];
